import { parseISO } from "date-fns/parseISO";
import { isFuture } from "date-fns/isFuture";
import { useDepositLimits } from "hooks/firestore/user/useDepositLimits";
import { useFiatCurrency } from "hooks/firestore/user/useFiatCurrency";

export const useMaxDepositAmount = (maxAmountOverrideCents?: number) => {
  const currency = useFiatCurrency();
  const { depositLimit, isLoading } = useDepositLimits(currency);

  const limitExpiry =
    depositLimit?.expiresAt && parseISO(depositLimit.expiresAt);
  const maxAmount =
    limitExpiry && isFuture(limitExpiry)
      ? depositLimit?.effectiveRemainingDailyAmount ??
        depositLimit?.remainingDailyAmount
      : depositLimit?.effectiveMaximumDailyAmount ??
        depositLimit?.maximumDailyDepositAmount;

  const cappedAmount =
    typeof maxAmount === "number" &&
    typeof maxAmountOverrideCents === "number" &&
    maxAmount > maxAmountOverrideCents
      ? maxAmountOverrideCents
      : maxAmount;

  return {
    maxDepositAmount: cappedAmount,
    isLoading,
  };
};
